module.exports = __webpack_public_path__ + "static/media/SuperhumanLogo.29392556.avif";